// 開く演出はアプリで最初に開いたときと、そのタブを30分間開かなかったときだけ（本人10/30）。
// 「30分」はタブごとに最後に開いた時刻から数える（Claudeの読み。アプリを閉じていた時間の意味なら直す）
const GAP_MS = 30 * 60 * 1000;
const seen = new Map<string, number>();

export function shouldAnimate(tab: string, now = Date.now()): boolean {
  const last = seen.get(tab);
  seen.set(tab, now);
  return last === undefined || now - last >= GAP_MS;
}

/** タブを離れたときも「最後に見ていた時刻」を更新する */
export function touch(tab: string, now = Date.now()): void {
  seen.set(tab, now);
}
